import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { GoogleMap, useJsApiLoader, MarkerF } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "400px",
};

const defaultCenter = { lat: 37.7749, lng: -122.4194 }; // Default Location (San Francisco)

const LocationMapDialog = ({ open, onClose, jobData }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDgm3VBE9YF9fIYqHU6Cue4OfJBtJBlxj4",
    libraries: ["places"],
  });

  const [mapCenter, setMapCenter] = useState(defaultCenter);

  useEffect(() => {
    if (jobData?.latitude && jobData?.longitude) {
      const lat = parseFloat(jobData.latitude);
      const lng = parseFloat(jobData.longitude);

      if (!isNaN(lat) && !isNaN(lng)) {
        setMapCenter({ lat, lng });
      }
    }
  }, [jobData]);

  console.log("Map Center:", mapCenter);

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading...</div>;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Location Details
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Divider sx={{ my: 1 }} />
        <Box sx={{ height: 400, width: "100%" }}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={mapCenter}
            zoom={15}
          >
            {/* Use MarkerF instead of Marker */}
            <MarkerF position={mapCenter} />
          </GoogleMap>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LocationMapDialog;
